import { directusAssetsRoute } from "../api/clients/directusClient";

/**
 * Returns a src path for the passed directus image UUID.
 *
 * @param imgFileName directus image file UUID.
 * @returns full src path string.
 */
export default function getDirectusImgUrl(imgFileName: string): string {
  return `${directusAssetsRoute}${imgFileName}`;
}
